import React from "react";

const BowlerCard = ({ bowler, matchInfo }) => {
  const getMatchInfo = () => {
    if (!matchInfo) return null;

    const { matchType, searchValue, totalMatches } = matchInfo;

    if (matchType === "usbcID") {
      return {
        type: "USBC ID",
        value: searchValue,
        count: totalMatches,
        description: `Matched by USBC ID: ${searchValue}`,
        color: "text-brand-gold-ink",
        bgColor: "bg-brand-cream",
        borderColor: "border-brand-charcoal/10",
      };
    } else if (matchType === "email") {
      return {
        type: "Email",
        value: searchValue,
        count: totalMatches,
        description: `Matched by email: ${searchValue}`,
        color: "text-brand-charcoal",
        bgColor: "bg-brand-cream",
        borderColor: "border-brand-charcoal/10",
      };
    }

    return null;
  };

  const matchDisplay = getMatchInfo();

  return (
    <div className="border border-gray-200 rounded-lg p-4">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h4 className="font-medium text-gray-900">{bowler.name}</h4>
            <span
              className={`px-2 py-1 text-xs rounded-full ${
                bowler.role === "primary"
                  ? "bg-brand-cream text-brand-charcoal"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {bowler.role === "primary" ? "Primary" : "Teammate"}
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
            <div>
              <div className="font-medium text-gray-700 mb-1">Contact Info</div>
              <div>Email: {bowler.email || "Not provided"}</div>
              {bowler.phone && <div>Phone: {bowler.phone}</div>}
              {bowler.usbcID && <div>USBC ID: {bowler.usbcID}</div>}
              <div>
                Average:{" "}
                {bowler.average
                  ? Math.round(parseFloat(bowler.average))
                  : "Not entered"}
              </div>
            </div>

            <div>
              <div className="font-medium text-gray-700 mb-1">
                Matching Status
              </div>
              {(() => {
                if (matchDisplay) {
                  return (
                    <div className="text-brand-charcoal">
                      ✅ Matched to existing bowler
                    </div>
                  );
                } else {
                  return (
                    <div className="text-gray-500">
                      📝 New bowler (no match)
                    </div>
                  );
                }
              })()}

              {/* Show match information if available */}
              {matchDisplay && (
                <div
                  className={`mt-2 p-2 rounded border ${matchDisplay.bgColor} ${matchDisplay.borderColor}`}
                >
                  <div className={`text-sm font-medium ${matchDisplay.color}`}>
                    🔍 {matchDisplay.type} Match Found
                  </div>
                  <div className="text-xs text-gray-600 mt-1">
                    {matchDisplay.description}
                  </div>
                  <div className="text-xs text-gray-500 mt-1">
                    {matchDisplay.count} match
                    {matchDisplay.count !== 1 ? "es" : ""} found
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Sidepot Information */}
          {bowler.sidepots && bowler.sidepots.length > 0 ? (
            <div className="mt-4">
              <div className="font-medium text-gray-700 mb-2">
                Sidepots ({bowler.sidepots.length})
              </div>
              <div className="space-y-1">
                {bowler.sidepots.map((sidepot, sidepotIndex) => (
                  <div
                    key={sidepotIndex}
                    className="flex justify-between items-center text-sm"
                  >
                    <span className="text-gray-600">{sidepot.eventName}</span>
                    <span className="font-medium">${sidepot.entryFee}</span>
                  </div>
                ))}
              </div>
              <div className="mt-2 pt-2 border-t border-gray-200">
                <div className="flex justify-between items-center text-sm font-medium">
                  <span>Total Sidepot Cost:</span>
                  <span>${bowler.totalSidepotCost}</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-4 text-sm text-gray-500">
              No sidepots selected
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BowlerCard;
